import { render } from "./GoodsSection.vue?vue&type=template&id=3968bb87"
import script from "./GoodsSection.vue?vue&type=script&lang=js"
export * from "./GoodsSection.vue?vue&type=script&lang=js"

import "./GoodsSection.vue?vue&type=style&index=0&id=3968bb87&lang=css"

import exportComponent from "C:\\Users\\knhmb\\Documents\\Khalid\\Job\\MarvelConnect Technology\\Projects\\One Shop Online Shopping\\one-shop-online-shopping\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__